import { defineNuxtPlugin } from '#app'
import VueGtag from 'vue-gtag-next'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  
  // GA4 Ölçüm Kimliği config'den alınıyor
  const gtagId = config.public.gtag?.id
  
  // GA4 debug modu config'den alınıyor
  const gtagDebug = config.public.gtag?.debug || false
  
  // GA4 kimliği tanımlı ise plugin'i yükle
  if (gtagId) {
    nuxtApp.vueApp.use(VueGtag, {
      property: {
        id: gtagId
      },
      isEnabled: process.client, // Sadece client-side çalışsın
      useDebugger: gtagDebug,   // Debug modu
      customResourceURL: 'https://www.googletagmanager.com/gtag/js'
    })
    
    console.log(`[Google Analytics] GA4 initialized with ID: ${gtagId}${gtagDebug ? ' (Debug Mode)' : ''}`)
  } else {
    console.warn('[Google Analytics] GA4 ID not configured')
  }
}) 